import DownloadService from '../download.service';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const downloadReport = createAsyncThunk<void, { fileName: string; PreSignedUrl: string }>(
  'report/download/csv',
  async ({ fileName, PreSignedUrl }) => {
    await DownloadService.downloadReport(PreSignedUrl, fileName);
  }
);
